import adminStore from 'Reducers/store/adminStore';
import clientStore from 'Reducers/store/clientStore';

export const registerTimeout = (handleTimeout, type) => {
    // Add a server timeout for 5 seconds
    const timeoutId = window.setTimeout(handleTimeout, 10000);
    const intervalId = window.setInterval(() => {
        if (
            (adminStore && !adminStore.getState().validation[type].pending) ||
            (clientStore && !clientStore.getState().validation[type].pending)
        ) {
            window.clearTimeout(timeoutId);
            window.clearInterval(intervalId);
        }
    }, 100);

    // Clear the interval manually after 5 seconds have passed
    window.setTimeout(() => window.clearInterval(intervalId), 10000);
};